import Datatable from "./datatable_controller";

export default class extends Datatable {
  static targets = ['filter']

  connect() {
    super.connect();
  }

  // A status radio was chosen in the dropdown: mirror its value onto the hidden
  // `status` input (the datatable filter target) and reload so the table reflects
  // the new filter immediately.
  selectStatus(event) {
    const status = event.target.value
    this.filterTargets.forEach((filter) => { filter.value = status })
    this.dataTable.draw()
  }

  // Apply just closes the dropdown — the table already reflects the chosen status.
  applyStatusFilter() {
    this.dataTable.draw()
  }

  // Cancel/clear: drop the status filter and reload the unfiltered list.
  removeStatusFilter() {
    this.element.querySelectorAll('.status-filter-radio').forEach((radio) => { radio.checked = false })
    this.filterTargets.forEach((filter) => { filter.value = '' })
    this.dataTable.draw()
  }

  manipulateData(data) {
    this.filterTargets.map((filter) => {
      data[filter.name] = $(filter).val()
    })

    return data
  }

  get columns() {
    return [
      { data: "category"},
      { data: "type"},
      { data: "subject"},
      { data: "status"},
      { data: "recipients"},
      { data: "last_updated"},
      { data: "actions"},
    ];
  }

  get searching() {
    return true;
  }

  get ordering() {
    return false;
  }
}
